import "./PrepaidCreditTools.scss";

import React, { useState, useEffect, useContext } from "react";
import request from "request";
import usesFeatures from "usesFeatures";
import { ApplicationContext } from "ApplicationContext";

import Header from "Header";
import CheckBarcodeTab from "./CheckBarcodeTab";
import CreateCreditTab from "./CreateCreditTab";
import ResetCreditsTab from "./ResetCreditsTab";


const PrepaidCreditTools = ({
  fetchData,
  dataFetched,
  pageData,
  pagy,
  updateWith,
  dataSource = "internal",
  headers = {
    code: "Code",
    initialBalance: "Starting Balance",
    currentBalance: "Current Balance",
    venue: "Venue",
    status: "Status",
    createdAt: "Created"
  }
}) => {
  const [activeTab, setActiveTab] = useState("check");
  const [venues, setVenues] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage] = useState(10);

  const context = useContext(ApplicationContext);

  useEffect(() => {
    fetchCredits();
    if (dataSource === "internal") {
      fetchVenues();
    }
  }, []);

  const fetchVenues = () => {
    let req = request.get(`${dataSource}/venues`);
    req.then(({data}) => {
      console.log(data);
      updateWith({venues: data.pageData});
      setVenues(data.pageData);
    });
  };

  const fetchCredits = (newPage = 1, filterParams = '') => {
    setPage(newPage);
    const baseParams = `page=${newPage}&per_page=${perPage}`;
    const queryString = filterParams ? `${baseParams}&${filterParams}` : baseParams;
    fetchData(`${dataSource}/prepaid_credits?${queryString}`);
  };

  const setActiveTabHandler = (tab) => {
    setActiveTab(tab);
  };

  if (!dataFetched) return false;

  return (
    <div className="PrepaidCreditTools">
      <Header text="Prepaid Credit Tools">
        <div className="tabs">
          <ul>
            <li className={activeTab === "check" ? "is-active" : ""}>
              <a onClick={() => setActiveTabHandler("check")}>Check Barcode</a>
            </li>
            <li className={activeTab === "create" ? "is-active" : ""}>
              <a onClick={() => setActiveTabHandler("create")}>Create Credit</a>
            </li>
            <li className={activeTab === "reset" ? "is-active" : ""}>
              <a onClick={() => setActiveTabHandler("reset")}>List Credits</a>
            </li>
          </ul>
        </div>
      </Header>

      <div className="columns is-multiline">
        {activeTab === "check" && <CheckBarcodeTab dataSource={dataSource}/>}

        {activeTab === "create" &&
          <CreateCreditTab
            venues={venues}
            fetchCredits={fetchCredits}
            dataSource={dataSource}
          />
        }

        {activeTab === "reset" &&
          <ResetCreditsTab
            prepaidCredits={pageData}
            pagy={pagy}
            fetchCredits={fetchCredits}
            dataSource={dataSource}
            headers={headers}
          />
        }
      </div>
    </div>
  );
};

export default usesFeatures(["data", "pagination"], PrepaidCreditTools);
